import AdminAccommodationTable from "../../components/Admin/AdminAccommodationTable";

function AdminAccommodation() {
  return <AdminAccommodationTable></AdminAccommodationTable>;
}

export default AdminAccommodation;
